var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 1.33203V14.6565L3.99651 13.9903L5.32896 14.6565L6.66141 13.9903L7.99386 14.6565L9.32631 13.9903L10.6588 14.6565L11.9912 13.9903L13.3237 14.6565V1.33203L11.9912 1.99826L10.6588 1.33203L9.32631 1.99826L7.99386 1.33203L6.66141 1.99826L5.32896 1.33203L3.99651 1.99826L2.66406 1.33203Z",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6599 5.33008H6.66253C6.30914 5.33008 5.97023 5.47046 5.72034 5.72034C5.47046 5.97023 5.33008 6.30914 5.33008 6.66253C5.33008 7.01592 5.47046 7.35483 5.72034 7.60471C5.97023 7.8546 6.30914 7.99498 6.66253 7.99498H9.32743C9.68082 7.99498 10.0197 8.13536 10.2696 8.38524C10.5195 8.63513 10.6599 8.97404 10.6599 9.32743C10.6599 9.68082 10.5195 10.0197 10.2696 10.2696C10.0197 10.5195 9.68082 10.6599 9.32743 10.6599H5.33008",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99414 11.6586V4.33008",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.5cce929de78f1e2cb9b82f2a3a68478b.svg";
export { ForwardRef as ReactComponent };